angular.module('Itao.IndicatorMap').directive('districtCheckboxes', ['mapConfig', 'communeConfig', function (mapConfig, communeConfig) {
  'use strict';

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'districtCheckboxes.html',
    scope: {
      selectedDataLayer: '=',
      disabledDistrictKeys: '=',
      noDataDistricts: '=',
    },
    link: function (scope) {
      scope.disabledDistrictKeys = scope.disabledDistrictKeys || [];

      jQuery('#districtToggle').click(function () {
        jQuery(this).closest('.district-container').toggleClass('open');
      });

      // Toggle selection for a given district by key
      scope.toggleSelection = function toggleSelection(districtKey) {
        var index = scope.disabledDistrictKeys.indexOf(districtKey);
        if (index > -1) {
          scope.disabledDistrictKeys.splice(index, 1);
        } else {
          scope.disabledDistrictKeys.push(districtKey);
        }
      };

      scope.uncheckAll = function toggleSelection() {
        if (scope.disabledDistrictKeys.length) {
          scope.disabledDistrictKeys = [];
        } else {
          scope.disabledDistrictKeys = Object.keys(scope.selectedDataLayer.districts).map(function (num) {
            return scope.selectedDataLayer.districts[num].key;
          }).filter(function (key) {
            return ['ost', 'west', 'de'].indexOf(key.toLowerCase()) === -1;
          });
        }
      };

      scope.hasData = function (districtKey) {
        return scope.noDataDistricts ? scope.noDataDistricts.indexOf(districtKey) === -1 : true;
      };

      scope.$watch('selectedDataLayer', function (dataLayer) {
        if (dataLayer && dataLayer.hasOwnProperty('districts')) {
          var oldKeys = angular.copy(scope.disabledDistrictKeys);
          var newKeys = Object.keys(dataLayer.districts).map(function (num) {
            return dataLayer.districts[num].key;
          });
          angular.forEach(oldKeys, function (oldKey) {
            if (newKeys.indexOf(oldKey) === -1) {
              scope.disabledDistrictKeys.splice(scope.disabledDistrictKeys.indexOf(oldKey), 1);
            }
          });
        }
      });
    }
  };
}]);
